import apiClient from '@/lib/api';
import type { BackofficeRole } from '@/services/team';

export interface AdminUser {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  avatarUrl?: string;
  timezone?: string;
  isAdmin: boolean;
  role: BackofficeRole;
}

export const adminAuthService = {
  login: async (credentials: any) => {
    // We hit the standard auth endpoint to get a generic token
    const response = await apiClient.post('/auth/login', credentials);
    return response.data;
  },

  getMe: async (): Promise<AdminUser> => {
    // Then we query the admin endpoint to ensure we have access and get admin profile
    const response = await apiClient.get('/admin/auth/me');
    return response.data.data.user;
  },

  logout: async () => {
    try {
      await apiClient.post('/auth/logout');
    } catch (e) {
      // Ignore errors on logout
    }
  },

  updateProfile: async (data: {
    firstName?: string;
    lastName?: string;
    email?: string;
    timezone?: string;
  }) => {
    try {
      const response = await apiClient.patch('/auth/profile', data);
      return { success: true, user: response.data.data.user };
    } catch (error: any) {
      return { success: false, error: error.response?.data?.message || 'Failed to update profile' };
    }
  },

  changePassword: async (currentPassword: string, newPassword: string, newPasswordConfirmation: string) => {
    try {
      await apiClient.post('/auth/change-password', {
        currentPassword,
        password: newPassword,
        passwordConfirmation: newPasswordConfirmation,
      });
      return { success: true };
    } catch (error: any) {
      return { success: false, error: error.response?.data?.message || 'Failed to change password' };
    }
  }
};
